var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3.85a8.15 8.15 0 0 0-6.647 12.867c2-1.003 4.259-1.567 6.647-1.567s4.646.564 6.647 1.567A8.15 8.15 0 0 0 12 3.85m7.538 14.49A9.8 9.8 0 0 0 21.85 12c0-5.44-4.41-9.85-9.85-9.85S2.15 6.56 2.15 12a9.8 9.8 0 0 0 2.333 6.365A9.83 9.83 0 0 0 12 21.85a9.83 9.83 0 0 0 7.538-3.51m-2.065-.3A13.1 13.1 0 0 0 12 16.85a13.1 13.1 0 0 0-5.473 1.19A8.12 8.12 0 0 0 12 20.15a8.12 8.12 0 0 0 5.473-2.11M12 7.85a2.15 2.15 0 1 0 0 4.3 2.15 2.15 0 0 0 0-4.3M8.15 10a3.85 3.85 0 1 1 7.7 0 3.85 3.85 0 0 1-7.7 0",
  clipRule: "evenodd"
})));
export default SvgUserCircle;